import api from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
class UploadService {
  uploadProjectFile (params){
    return api.post(`${backendUrl}/user/company_info`, params, headers).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // 2.1 �ռ� �ϴ��ļ� ��ȡ�ϴ����
  uploadResult (params){
    return api.postArr(`${backendUrl}/upload_history/upload_result`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // 2.2 �嵥����� �ϴ� ��ȡ�ϴ����
  uploadResultBigData (params){
    return api.postArr(`${backendUrl}/data_manage/upload_result`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
}
export default new UploadService()
